import { Moon, Sun, Monitor } from "lucide-react"
import { useTheme } from "@/components/theme-provider"

import { Button } from "@/components/ui/button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"

export function ThemeToggle() {
  const { theme, setTheme, isTransitioning } = useTheme()

  const getThemeLabel = () => {
    if (theme === 'light') return 'Light';
    if (theme === 'dark') return 'Dark';
    return 'System';
  };

  const getThemeIcon = () => {
    if (theme === 'light') return <Sun className="h-4 w-4" />;
    if (theme === 'dark') return <Moon className="h-4 w-4" />;
    return <Monitor className="h-4 w-4" />;
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button 
          variant="ghost" 
          size="icon" 
          className={`h-8 w-8 transition-all duration-200 ${
            isTransitioning ? 'scale-95 opacity-75' : 'hover:scale-105'
          }`}
        >
          {getThemeIcon()}
          <span className="sr-only">Toggle theme</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-40 bg-background border shadow-lg z-50">
        <DropdownMenuItem 
          onClick={() => setTheme("light")} 
          className={`flex items-center gap-2 transition-all duration-200 hover:scale-[1.02] ${
            theme === 'light' ? 'bg-accent' : ''
          }`}
        >
          <Sun className="h-4 w-4 transition-transform duration-200" />
          Light
        </DropdownMenuItem>
        <DropdownMenuItem 
          onClick={() => setTheme("dark")} 
          className={`flex items-center gap-2 transition-all duration-200 hover:scale-[1.02] ${
            theme === 'dark' ? 'bg-accent' : ''
          }`}
        >
          <Moon className="h-4 w-4 transition-transform duration-200" />
          Dark
        </DropdownMenuItem>
        <DropdownMenuItem 
          onClick={() => setTheme("system")} 
          className={`flex items-center gap-2 transition-all duration-200 hover:scale-[1.02] ${
            theme === 'system' ? 'bg-accent' : ''
          }`}
        >
          <Monitor className="h-4 w-4 transition-transform duration-200" />
          System
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}